/**
 * Generic multi-select toggle for a string array — "is this value in the
 * set, flip it" — shared by every chip picker in the feedback UI: the
 * per-message reason chips (message-reaction-panel.tsx) and the conversation
 * rating card's attribute chips (conversation-rating-card.tsx). Both are the
 * exact same operation (toggle membership, order-preserving, no dedup logic
 * needed since a chip can only be clicked once to add itself), so this is
 * factored out once rather than reimplemented per picker.
 */
export function toggleSelection(selected: string[], value: string): string[] {
  return selected.includes(value)
    ? selected.filter((v) => v !== value)
    : [...selected, value];
}
